import React from 'react';
import Card from '../../../components/ui/Card/Card';
import Skeleton from '../../../components/ui/Skeleton/Skeleton';
import styles from '../Dashboard.module.css';
import kpi from './KpiCards.module.css';

const DashboardSkeleton: React.FC = () => (
  <div className={`${styles.page} dylo-animate-in`}>
    {/* KPI row */}
    <div className={kpi.grid}>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className={kpi.card}>
          <Skeleton width={42} height={42} radius={10} />
          <div style={{ flex: 1 }}>
            <Skeleton width="70%" height={12} />
            <div style={{ height: 8 }} />
            <Skeleton width="40%" height={18} />
          </div>
        </div>
      ))}
    </div>

    <div className={styles.topGrid}>
      <div className={styles.mainCol}>
        <Card>
          <Skeleton width={180} height={14} />
          <div style={{ height: 18 }} />
          <Skeleton height={230} radius={12} />
        </Card>
        <Card dark>
          <Skeleton height={280} radius={12} />
        </Card>
      </div>
      <div className={styles.sideCol}>
        <Card>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <Skeleton width={84} height={84} circle />
            <div style={{ flex: 1 }}>
              <Skeleton width="80%" height={12} />
              <div style={{ height: 8 }} />
              <Skeleton width="50%" height={18} />
            </div>
          </div>
        </Card>
        <Card>
          <Skeleton height={150} radius={12} />
        </Card>
        <Card>
          <Skeleton height={170} radius={999} style={{ borderRadius: '50%', width: 170, margin: '0 auto' }} />
          <div style={{ height: 16 }} />
          <Skeleton width="60%" height={12} />
          <div style={{ height: 10 }} />
          <Skeleton width="90%" height={10} />
          <div style={{ height: 8 }} />
          <Skeleton width="80%" height={10} />
        </Card>
      </div>
    </div>

    <div className={styles.bottomRow}>
      <Card>
        <Skeleton width={160} height={14} />
        <div style={{ height: 18 }} />
        <Skeleton height={220} radius={12} />
      </Card>
      <Card>
        <Skeleton width={160} height={14} />
        <div style={{ height: 18 }} />
        <Skeleton height={220} radius={12} />
      </Card>
    </div>
  </div>
);

export default DashboardSkeleton;
